// Librerías
import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';

// Componentes
import Navbar from '../components/Navbar/Navbar';
import AloharViajaMasLanding from '../landing-plans/src/AloharViajaMasLanding';
import Footer from '../components/Footer/Footer';

// Estilos
import '../assets/styles/ViajaMas/viaja-mas.css';

ReactGA.initialize('G-RFYCNS3LB1');

const AloharViajaMas = () => {
  useEffect(() => {
    // Track page view
    ReactGA.send({ hitType: 'pageview', page: '/viaja-mas' });
  }, []);

  return (
    <>
      <Helmet>
        <title>Viajá+ Banco Nación | Financiá tu estadía en Alohar</title>
        <meta
          name="description"
          content="Pagá tu alojamiento en Alohar con Viajá+ del Banco Nación. Financiá tus vacaciones en cuotas fijas y aprovechá descuentos exclusivos en hotelería."
        />
        <meta
          name="keywords"
          content="viaja mas, banco nacion, financiacion, alojamiento, alohar, turismo argentina, cuotas sin interes"
        />
        <meta property="og:title" content="Viajá+ Banco Nación | Financiá tu estadía en Alohar" />
        <meta
          property="og:description"
          content="Pagá tu alojamiento en Alohar con Viajá+ del Banco Nación. Financiá tus vacaciones en cuotas fijas."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <Navbar isLanding={true} logo="orange" showMobile={true} icon={true} />
      
      <main className="viaja-mas-page">
        <AloharViajaMasLanding />
        <Footer />
      </main>
    </>
  );
};

export default AloharViajaMas;
